exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity__field .v-input__slot {\n  min-height: 36px !important;\n}\n.quantity__field--sp .v-input__slot {\n  min-height: 20px !important;\n}", ""]);

// exports
